

<footer>
  <div class="main-footer">
    <div class="container">
      <div class="row footer-main-row">
        <div class="col-lg-4 col-md-12 img-col">
          <!-- <img src="../assets/images/logos/iata-logo.png" alt="iata" class="footer-logo">
          <img src="../assets/images/logos/speditor-logo.png" alt="iata" class="footer-logo">
          <img src="../assets/images/logos/aeo-logo.png" alt="aeo" class="footer-logo"> -->
          <a href="https://www.iata.org" target="_blank" class="footer-logo-link">
            <img src="../assets/images/logos/iata-logo.png" alt="iata" class="footer-logo">
          </a>
          <a href="https://urldefense.proofpoint.com/v2/url?u=https-3A__flyers.straitair.com_NSAB-252B2015-252B-28UK-29.pdf&d=DwMFAw&c=9-1UErDf9ZNwjmkEH672vg&r=pN5iCwAkRP0DluT-5CO3ZJ_TKfxTSgS2I52ge0K8vjI&m=QKzStardPLlRLoMGzHRe8tWDdCrLWhmniXs2UIxpYEwMdhTXWeFY4_gMS55fO0bY&s=RpZnpp1aJXRNGQWilsRav9gRkB7HhbD1I_rYbda4gpI&e=" class="footer-logo-link" target="_blank">
            <img src="../assets/images/logos/speditor-logo.png"   alt="iata" class="footer-logo">
          </a>
          <a href="https://ec.europa.eu/taxation_customs/general-information-customs/customs-security/authorised-economic-operator-aeo_en" target="_blank" class="footer-logo-link">
            <img src="../assets/images/logos/aeo-logo.png" alt="aeo" class="footer-logo">
          </a>
        </div>
        <div class="col-lg-6 col-md-9 d-flex res-d-block footer-serv-col pe-0">
          <div class="row w-100">
            <div class="col-lg-6 col-md-6 col-7">
              <ul class="services-links">
                <!-- <li class="border-right pe-3 cust-width">Our Services</li> -->
                <li class="border-right pe-3 cust-width"></li>
                <li class="pb-0">
                  <ul class="list-unstyled ps-3">
                    <li><a routerLink="air-service">Air Services</a></li>
                    <li><a routerLink="ocean-service">Ocean Services</a></li>
                    <li><a routerLink="verticals">Verticals</a></li>
                    <li><a routerLink="value-added-service">Value Added Services</a></li>
                  </ul>
                </li>
              </ul>
            </div>

            <div class="col-lg-6 col-md-6 col-5">
              <ul class="services-links pe-0 ps-4 res-ps-0">
                <!-- <li class="border-right pe-3 cust-width">About Strait Air</li> -->
                <li class="border-right pe-3 cust-width"></li>
                <li>
                  <ul class="list-unstyled ps-3" style="width: 300px;">
                    <li><a routerLink="apps">Apps</a></li>
                    <!-- <li><a href="#">News</a></li> -->
                    <li><a routerLink="contact">Contact Us</a></li>
                    <li class="pb-0">
                      <ul class="list-unstyled">
                        <li class="d-inline-block pe-3">
                          <a href="https://www.linkedin.com/company/30166048/admin/" target="_blank"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
                        </li>
                        <li class="d-inline-block pe-3">
                          <a href="https://www.facebook.com/straitairtransport" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                        </li>
                        <li class="d-inline-block twitter">
                          <!-- <a href="https://twitter.com/AirStrait" target="_blank"><img src="../assets/images/logos/X-logo-13by14-Black.png"></a> -->
                          <a href="https://twitter.com/AirStrait" target="_blank"><svg width="15px" height="15px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg></a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <p class="mb-2 part-of-text d-inline-block"><strong>Part of</strong></p>
                      <a href="https://www.scan-group.com" target="_blank" style="margin-left:5px;display: inline-block;font-family: Arial black;font-weight: bold;text-decoration: none;color: #213654;"><p>Scan-Group</p></a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- <div class="col-lg-2 col-md-2 col-12 d-flex justify-content-start footer-last-col">
        <div class="text-center pt-4">
          <p class="mb-2 part-of-text"><strong>Part of</strong></p>
          <a href="https://www.scan-group.com" target="_blank" class="footer-logo-link">
            <img src="../assets/images/logos/Scan-Group logo Strait Air.png" alt="scan-shipping-logo" class="scan-logo">
          </a>
        </div>

      </div> -->
    </div>
  </div>
</div>

<div class="bottom-footer">
  <div class="container">
    <div class="footer-links">
      <ul class="mb-0 list-unstyled">
        <li><a class="text-white" style="text-decoration: none;">Strait Air Transport ©2000-{{currentYear}}. All Rights Reserved</a></li>
        <li><a routerLink="bl-terms-conditions" class="text-white linked">B/L Terms & Conditions</a></li>
        <li><a routerLink="airway-bill-conditions" class="text-white linked">Airway Bill Conditions of Contract</a></li>
        <li><a routerLink="terms-of-use" class="text-white linked">Terms Of Use</a></li>
        <li><a routerLink="privacy-policy" class="text-white linked">Privacy Policy</a></li>
        <li><a routerLink="sitemap" class="text-white linked">Sitemap</a></li>
      </ul>
    </div>
  </div>
</div>

@if (isShow) {
  <button (click)="gotoTop()" class="scroll-btn">
    <i class="fa fa-chevron-up" aria-hidden="true"></i>
  </button>
}
</footer>

